import http from 'plugins/axios';

export default {
  types() {
    return http.get({ url: '/ta/admin/tenant/public-subject/types' });
  },
  page({ page = 1, size = 20, userType } = {}) {
    let url = `/ta/admin/tenant/public-subject/page?page=${page}&size=${size}`;
    if (userType != null && userType !== '') {
      url += `&userType=${userType}`;
    }
    return http.get({ url });
  },
  create({ userType, remark }) {
    return http.post({
      url: '/ta/admin/tenant/public-subject/create',
      data: { userType, remark },
    });
  },
};
